var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Dialog,{attrs:{"dialog":_setup.dlg,"xno-sub-title":"","no-content-padding":""}},[_c(_setup.Datatable,{staticClass:"full-height",attrs:{"dt":_setup.dt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }